import { APP_ROUTES } from "../constants";

export const SolutionUtil = {
  buildSolutionDetailPath
};

function buildSolutionDetailPath(solutionCode: string): string {
  return solutionCode ? APP_ROUTES.PAGEMANAGEMENT.SOLUTION.DETAIL.replace(":solutionCode", solutionCode) : APP_ROUTES.PAGEMANAGEMENT.SOLUTION.BASE;
}